import Header from '../components/Header'
import Footer from '../components/Footer'

const Terms = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <div className="bg-white">
          <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h1 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                Terms of Service
              </h1>
              <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">
                Effective Date: June 15, 2023
              </p>
            </div>

            <div className="prose prose-lg text-gray-500 mx-auto">
              <h2 className="text-2xl font-bold text-gray-900">1. Acceptance of Terms</h2>
              <p>
                By accessing or using any services provided by TheMarketingFeeds.com ("we," "us," or "our"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">2. Services Provided</h2>
              <p>
                TheMarketingFeeds.com provides digital marketing services including but not limited to:
              </p>
              <ul className="list-disc pl-6">
                <li>SaaS product development</li>
                <li>Email marketing campaigns</li>
                <li>SEO strategy and implementation</li>
                <li>Google and Facebook advertising</li>
                <li>Social media marketing</li>
                <li>Content creation and strategy</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">3. Client Responsibilities</h2>
              <p>As a client, you agree to:</p>
              <ul className="list-disc pl-6">
                <li>Provide accurate and complete information for service delivery</li>
                <li>Grant necessary access to digital assets for service implementation</li>
                <li>Make timely payments as agreed in service contracts</li>
                <li>Comply with all applicable laws and regulations</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">4. Payment Terms</h2>
              <p>
                Our services are provided under the following payment conditions:
              </p>
              <ul className="list-disc pl-6">
                <li>Fees are outlined in individual service agreements</li>
                <li>Payment is typically due within 15 days of invoice date</li>
                <li>Late payments may incur interest charges of 1.5% per month</li>
                <li>We reserve the right to suspend services for non-payment</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">5. Intellectual Property</h2>
              <p>
                All intellectual property rights are protected as follows:
              </p>
              <ul className="list-disc pl-6">
                <li>Client retains ownership of all pre-existing materials</li>
                <li>TheMarketingFeeds.com retains ownership of proprietary tools and methodologies</li>
                <li>Final deliverables are transferred to client upon full payment</li>
                <li>Unauthorized use of our materials is strictly prohibited</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">6. Confidentiality</h2>
              <p>
                Both parties agree to maintain confidentiality of all sensitive information shared during the engagement, including:
              </p>
              <ul className="list-disc pl-6">
                <li>Business strategies and plans</li>
                <li>Customer and marketing data</li>
                <li>Proprietary methodologies</li>
                <li>Financial information</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">7. Service Limitations</h2>
              <p>
                While we strive for excellence, please note:
              </p>
              <ul className="list-disc pl-6">
                <li>Results may vary based on market conditions and other factors</li>
                <li>We cannot guarantee specific performance metrics</li>
                <li>Third-party platform changes may affect service outcomes</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">8. Termination</h2>
              <p>
                Either party may terminate services with written notice:
              </p>
              <ul className="list-disc pl-6">
                <li>30 days notice for monthly engagements</li>
                <li>60 days notice for annual contracts</li>
                <li>Immediate termination for material breach of terms</li>
              </ul>
              <p className="mt-4">
                Outstanding fees remain due upon termination.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">9. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law:
              </p>
              <ul className="list-disc pl-6">
                <li>We are not liable for indirect, incidental, or consequential damages</li>
                <li>Our total liability is limited to fees paid for the affected services</li>
                <li>We are not responsible for third-party actions or platform changes</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">10. Indemnification</h2>
              <p>
                You agree to indemnify and hold harmless TheMarketingFeeds.com from any claims arising from:
              </p>
              <ul className="list-disc pl-6">
                <li>Your breach of these terms</li>
                <li>Your use of our services</li>
                <li>Your violation of any laws or third-party rights</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">11. Governing Law</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of the State of New York, without regard to its conflict of law provisions.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">12. Changes to Terms</h2>
              <p>
                We may modify these Terms at any time. Continued use of our services after changes constitutes acceptance of the modified Terms.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">13. Contact Information</h2>
              <p>
                For questions about these Terms, please contact us at:
              </p>
              <address className="not-italic mt-2">
                TheMarketingFeeds.com<br />
                Attn: Legal Department<br />
                123 Marketing Street<br />
                New York, NY 10001<br />
                Email: hello@themarketingfeeds.com<br />
                Phone: (555) 123-4567
              </address>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Terms